"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
function changeVolume(sourceId, volume) {
  return (0, _utils.actionCreator)(_types.MEDIA_PLAYER_VOLUME_CHANGE, {
    sourceId: sourceId,
    volume: volume
  });
}
var _default = exports["default"] = changeVolume;